import UserActions from "../Types";
import responseHandler from "../../utils/responseHandler";
import Instance from "../../utils/apiNip";
import Storage from "../../utils/storage";
import responseHandler2 from "../../utils/responseHandler2";
import { failureFunction, startFunction, successFunction } from "../../utils/Functions/CheckFunction";

// GET NAME ENQUIRY VALUES
export const getNameEnquiryStart = () => ({
    type: UserActions.GET_NAME_ENQUIRY_VALUES_START
})

export const getNameEnquirySuccess = payload => ({
    type: UserActions.GET_NAME_ENQUIRY_VALUES_SUCCESS,
    payload
})

export const getNameEnquiryFailure = payload => ({
    type: UserActions.GET_NAME_ENQUIRY_VALUES_FAILURE,
    payload
})

// SEND NAME ENQUIRY VALUES
export const sendNameEnquiryStart = () => ({
    type: UserActions.SEND_NAME_ENQUIRY_VALUES_START
})

export const sendNameEnquirySuccess = payload => ({
    type: UserActions.SEND_NAME_ENQUIRY_VALUES_SUCCESS,
    payload
})

export const sendNameEnquiryFailure = payload => ({
    type: UserActions.SEND_NAME_ENQUIRY_VALUES_FAILURE,
    payload
})

// SEND FUND TRANSFER VALUES
export const sendFundTransferStart = () => ({
    type: UserActions.SEND_FUND_TRANSFER_VALUES_START
})

export const sendFundTransferSuccess = payload => ({
    type: UserActions.SEND_FUND_TRANSFER_VALUES_SUCCESS,
    payload
})

export const sendFundTransferFailure = payload => ({
    type: UserActions.SEND_FUND_TRANSFER_VALUES_FAILURE,
    payload
})

// SEND STATUS QUERY VALUES
export const sendStatusQueryStart = () => ({
    type: UserActions.SEND_STATUS_QUERY_VALUES_START
})

export const sendStatusQuerySuccess = payload => ({
    type: UserActions.SEND_STATUS_QUERY_VALUES_SUCCESS,
    payload
})

export const sendStatusQueryFailure = payload => ({
    type: UserActions.SEND_STATUS_QUERY_VALUES_FAILURE,
    payload
})

// CLEAR NIP SUCCESS STATE
export const clearSuccessState = () => ({
    type: UserActions.CLEAR_NIP_SUCCESS_STATE,
})

// CLEAR NIP INTERACTION STATE
export const clearInteractionState = () => ({
    type: UserActions.CLEAR_NIP_INTERACTION_STATE,
})

export const getNameEnquiry = () => async dispatch => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"))

    dispatch(getNameEnquiryStart());
    API.get("sandbox/interaction/outward/default-details").then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(getNameEnquirySuccess(data.data));
        } else {
            dispatch(getNameEnquiryFailure(data));
        }
    })
}

export const sendOutwardInteractionValues = (name, payload) => async dispatch => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"))

    startFunction(name, dispatch);
    API.post(`sandbox/interaction/outward/${name}`, payload).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler2(response);
        if (ok) {
            successFunction(name, dispatch, data)
        } else {
            failureFunction(name, dispatch, data)
        }
    })
}


